import { FILTER_OPERATOR } from "../../../../../../shared/components/filters/contracts/TFilterOperator";
import IReportFilterCriteria from "../../../../../../shared/contracts/IReportFilterCriteria";
import IReportSaveFiltersBody from "../../../../../../shared/contracts/IReportSaveFiltersBody";

export default class ReportDataFiltersDialogService {

  static rangeFilterOperatorEnumValues = [
    FILTER_OPERATOR.BETWEEN,
    FILTER_OPERATOR.NOT_BETWEEN,
    FILTER_OPERATOR.BETWEEN_TWO_DATES,
    FILTER_OPERATOR.NOT_BETWEEN_TWO_DATES
  ];

  static getSaveFiltersBody = (filters: IReportFilterCriteria[]): IReportSaveFiltersBody => {

    const body: IReportSaveFiltersBody = {
      reportFilterCriterias: [...filters],
    }

    // ---
    return body;

  }

  static isOperatorValueFieldDdl = (operatorValueId: number) => operatorValueId !== 0;

  static isRangeFilterOperatorValue = (value: string): boolean => {
    return ReportDataFiltersDialogService.rangeFilterOperatorEnumValues.includes(value.toUpperCase() as FILTER_OPERATOR);
  }

  static isFilterOperatorBlank = (operator: string) => {
    return operator.toUpperCase() === FILTER_OPERATOR.BLANK || operator.toUpperCase() === FILTER_OPERATOR.NOT_BLANK;
  };

}